/*
 * @Author: chg
 * @LastEditors: chg
 * @Description: 移动端 - 公式问答
 */
import http from '../../utils/http.js'

// 获取任务详情
export function GetFactorTask (params) {
  const url = '/gptEvent/getFactorTask'
  return http.get(url, params)
}
// 下一步任务
export function ConstituentStocksNext (params) {
  const url = '/gptEvent/constituentStocksNext'
  return http.post(url, params)
}

// 根据 expressionId 获取表格信息
export function GetMatrixInfoByExpressionId (params) {
  const url = '/matrixInfo/getMatrixInfoByExpressionId'
  return http.get(url, params)
}

// 获取回测指标
export function GetStateValuesById (params) {
  const url = '/factorBase/getStateValuesById'
  return http.get(url, params)
}

// 常用因子列表
export function CommonFactorList (params) {
  const url = '/factorBase/commonFactorList'
  return http.get(url, params)
}

// 替换回测因子
export function ChangeFactor (params) {
  const url = '/gptEvent/changeFactor'
  return http.post(url, params)
}

// 指数曲线
export function BuildIndexData (params) {
  const url = process.env.H5_DOMAIN + '/factorAnswer/buildIndexData'
  return http.post(url, params)
}

// 坐标获取数据矩阵信息
export function GetMatrixByCoordinate (params) {
  const url = '/dataSupport/getMatrixByCoordinate'
  return http.get(url, params)
}

// 回测任务区间叠加图
export function GenerateFactorTaskOverlay (params) {
  const url = '/gptEvent/generateFactorTaskOverlay'
  return http.post(url, params)
}

// 事件区间叠加图
export function GenerateEventOverlay (params) {
  const url = '/gptEvent/generateEventOverlay'
  return http.post(url, params)
}

// 通过 ExpressionId 获取 JSON数据
export function GetJsonByExpressionId (params) {
  const url = '/refactor/getJsonByExpressionId'
  return http.get(url, params)
}



// WEBPACK FOOTER //
// ./src/api/whiteList/inclusionIndex.js